// axiosInstance, not the cachios client: the cache would hand a second
// caller the PREVIOUS user's in-flight response during a login-as-user relay
import {axiosInstance as http} from "@/http_client";

export default {
    state: {
        enrollments: null
    },
    getters: {
        enrollments: state => state.enrollments
    },
    mutations: {
        setEnrollments(state, enrollments) {
            state.enrollments = enrollments;
        }
    },
    actions: {
        getEnrollments({commit, rootGetters}) {
            // The portal "login as user" relay can swap users while a boot
            // load for the previous user is still in flight; a late response
            // for the old user must not overwrite the new user's rows.
            const forUser = rootGetters.currentUser && rootGetters.currentUser.id;
            return new Promise((resolve, reject) => {
                http.get('app/enrollments/').then(response => {
                    const nowUser = rootGetters.currentUser && rootGetters.currentUser.id;
                    if (nowUser !== forUser) return resolve(null);
                    commit('setEnrollments', response.data.enrollments);
                    resolve(response.data.enrollments);
                }).catch(err => {
                    console.log('err', err);
                    reject(err.response);
                });
            });
        },
    }
};
